export default "__VITE_ASSET__D21mLPH5__"